<template>
  <b-modal v-model="show" title="" centered size="lg" no-close-on-backdrop no-close-on-esc>
    <b-container fluid>
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="8">
          <img
            v-bind:src="baseURL + '/u/' + storage.photo"
            width="100%"
            height="auto"
          />
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-header>
      <b-row class="justify-content-md-center">
        <b-col cols="12" md="12">
          <!-- <b-button variant="light" size="sm" float-right @click="closeModal"
            >Cancel</b-button > -->
            <b-button variant="link" @click="closeModal"><i
                
                class="fa fa-close pr-4"
                style="color: red"
                
                aria-hidden="true"
              ></i></b-button>
        </b-col>
      </b-row>
    </template>

    <template v-slot:modal-footer>
      <b-row>
        <b-col cols="12" md="6">
          <b-button variant="light" size="sm" float-right @click="closeModal"
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ["storage"],
  data() {
    return {
      show: true,
    };
  },
  methods: {
    closeModal() {
      //   this.show=false
      this.$emit('stepper',{showImg : false})
    },
  },
};
</script>
